/**
 * Image lightbox
 */
class ATS_ImageLightbox {
  constructor() {
    this.initState();
    this.initEvents();
  }
  
  initState () {
    this.subpage = $('.subpage');
    this.subpageImageWrapper = this.subpage.find('.image-wrapper');
    this.image = this.subpageImageWrapper.find('a');

    if (!this.image) {
      return
    }

    this.subpage.append( '<div class="popup-image popup--is-hidden"><div class="popup-image-content"><img src="" class="image" alt=""></div><span class="close-popup"></span><span class="close-overlay"></span></div>' );
    this.popup = this.subpage.find('.popup-image');
    this.popupContent = this.subpage.find('.popup-image-content');
    this.popupClose = this.subpage.find('.close-popup');
    this.popupOverlay = this.subpage.find('.close-overlay');
    
    this.initEvents();
  }

  initEvents () {
    this.image.on('click', (e) => {
      e.preventDefault();

      setTimeout(() => {
        let imageURL = $(e.target).attr('href');
        this.popup.removeClass('popup--is-hidden');
        this.currentPopupImage = imageURL;
        this.showImage(this.currentPopupImage);
      }, 0);
    });

    this.popupClose.on('click', (e) => {
      e.preventDefault();
      this.popup.addClass('popup--is-hidden');
    });

    this.popupOverlay.on('click', (e) => {
      e.preventDefault();
      this.popup.addClass('popup--is-hidden');
    });
  }

  showImage (index) {
    let newImage = this.popup.find('.image');
    newImage.attr('src', index);
    this.popupContent.append(newImage);
  }
}
